import OtpInput from "react-otp-input";
import React, { forwardRef, HTMLInputTypeAttribute, useEffect, useMemo, useRef } from "react";
import { InputOtp, InputOtpProps } from "@nextui-org/react";
interface PasswordInputProps extends Omit<InputOtpProps, "length"> {
  length?: number;
  autoFocus?: boolean;
}
const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  const {
    value,
    onValueChange,
    variant = "default",
    length = 6,
    autoFocus = false,
    ...restProps
  } = props;
  return <InputOtp ref={ref} length={length} value={value} onValueChange={latestValue => {
    if (value?.length == 6 && latestValue?.length >= 6) return;
    onValueChange?.(latestValue);
  }} variant="bordered" className="w-full text-white" size={undefined} autoFocus={autoFocus} classNames={{
    input: "!text-white",
    segmentWrapper: "w-full justify-between",
    segment: "!bg-white/[0.16] !text-white border-red !size-12 data-[focus=true]:!size-12 data-[focus=true]:scale-100 data-[focus=true]:!outline-none rounded-2xl data-[focus=true]:!border data-[focus:true]:!border-description border !border-description",
    caret: "bg-white",
    passwordChar: "!text-white !bg-white !text-[1.3em]"
  }} isReadOnly radius={undefined} {...restProps} />;
});
PasswordInput.displayName = "PasswordInput";
export default PasswordInput;